<template>
  <div style="height:100%">
    <portal to="app-header">
      {{ $t('shiftSummary') }}
      <shift-selector v-if="currentDate && shiftList.length" />
      <v-tooltip bottom v-if="!isMobile">
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-on="on"
            v-bind="attrs"
            class="ml-2"
            :disabled="loading"
            @click="getDashboardData"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        {{ $t('lastRefreshed') }} <strong>{{ lastRefreshedAt }}</strong>
      </v-tooltip>
    </portal>
    <v-row v-if="currentDate">
      <v-col cols="12" lg="6" xl="5">
        <oee-summary />
      </v-col>
      <v-col cols="12" lg="6" xl="7" v-if="!isMobile">
        <v-row>
          <v-col cols="12">
            <shift-production />
          </v-col>
          <v-col cols="12">
            <shift-downtime />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ShiftSelector from './ShiftSelector.vue';
import OeeSummary from './widgets/OeeSummary.vue';
import ShiftProduction from './widgets/ShiftProduction.vue';
import ShiftDowntime from './widgets/ShiftDowntime.vue';

export default {
  name: 'ProductionSupervisorDashboard',
  components: {
    ShiftSelector,
    OeeSummary,
    ShiftProduction,
    ShiftDowntime,
  },
  data() {
    return {
      fetching: false,
    };
  },
  async created() {
    this.fetching = true;
    await this.getBusinessTime();
    await Promise.all([
      this.getShifts(),
      this.getMachines(),
      this.fetchMachines(),
      this.getOperators(),
      this.getRejectionReasons(),
      this.getDowntimeReasons(),
    ]);
    this.fetching = false;
  },
  computed: {
    ...mapState('userDashboard', [
      'currentDate',
      'lastRefreshedAt',
      'loading',
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapGetters('userDashboard', ['shiftList']),
  },
  methods: {
    ...mapActions('userDashboard', [
      'getBusinessTime',
      'getShifts',
      'getMachines',
      'fetchMachines',
      'getOperators',
      'getRejectionReasons',
      'getDowntimeReasons',
      'getDashboardData',
    ]),
  },
};
</script>
